<app-tab>
  <app-transport-interventions-toolbar
    [request]="request"></app-transport-interventions-toolbar>


  <app-transport-interventions-dashboard
    [hidden]="currentMenu.id !== 1 && backgroundMenu.id !== 1"
    [width]="width"
    [height]="height"
    [request]="request"></app-transport-interventions-dashboard>

  <app-transport-interventions-grid
    [hidden]="currentMenu.id !== 2 && backgroundMenu.id !== 2"
    [width]="width"
    [height]="height"
    [request]="request"></app-transport-interventions-grid>

  <app-transport-interventions-pivot-grid
    [hidden]="currentMenu.id !== 3 && backgroundMenu.id !== 3"
    [width]="width"
    [height]="height"
    [request]="request"></app-transport-interventions-pivot-grid>

  <app-transport-interventions-settings
    [visible]="currentMenu.id === 4"
    [width]="width"
    [height]="height"
    [request]="request"></app-transport-interventions-settings>
</app-tab>
